/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import {Button, FormGroup, Label, Col, Row, Input} from 'reactstrap'

import ReactTable from 'react-table-legacy'
import "react-table-legacy/react-table.css";

import InputNumber from 'rc-input-number';

import UploadFiles from '../../widgets/UploadFiles.js'

import {AppContext} from '../../AppContext';

class ObjectVersions extends React.Component
{
  componentDidMount()
  {
    this.fetchVersionData();
  }

  constructor(props)
  {
    super();

    this.transformToVersionedObject = this.transformToVersionedObject.bind(this);
    this.newVersionUploaded = this.newVersionUploaded.bind(this);

    this.state =
    {
      unlimitedVersionsChecked: false,
      versionsHaveSameNameChecked: false,
      versionsToRetain: null,
      numericInputDisabled: true,
      versions: undefined
    }

    this.toggleNamesMustMatch = this.toggleNamesMustMatch.bind(this);
    this.toggleUnlimitedVersions = this.toggleUnlimitedVersions.bind(this);
    this.versionsToRetainChanged = this.versionsToRetainChanged.bind(this);
    this.fetchVersionData = this.fetchVersionData.bind(this);
  }

  async fetchVersionData()
  {
    let bodyData = {objectId: this.props.selectedObject.objectId}
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getVersionData', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error getting object version history');
    this.setState(
    {
      unlimitedVersionsChecked: -1 === result.jsonData.versionsToRetain ? true : false,
      versionsHaveSameNameChecked: 'Y' === result.jsonData.versionsHaveSameName ? true : false,
      versionsToRetain: -1 === result.jsonData.versionsToRetain ? null : result.jsonData.versionsToRetain,
      numericInputDisabled: -1 === result.jsonData.versionsToRetain ? true : false,
      versions: result.jsonData.versions
    });
  }

  newVersionUploaded(uploadError)
  {
    if (uploadError) return;
    this.context.postNotification('success', 'New version uploaded.');
    this.fetchVersionData();
    this.props.refreshVaultViewTab();
  }

  render()
  {
    if (undefined === this.props.selectedObject) return false;

    if ('N' === this.props.selectedObject.versionedObject)
      return this.renderUnversionedObject();
    else
      return this.renderVersionedObject();
  }

  renderUnversionedObject()
  {
    if ('N' === this.props.selectedObject.immutableObject)
      return( 
        <div>
          <Row style={{paddingTop: "10px"}}>
            <Col sm='7'><p>This object has not been versioned.  If you would like to transform it to a versioned object press the 'Transform' button</p></Col>
            <Col>
              <Row>
                <Col><Button className="float-center" color="secondary" onClick={this.transformToVersionedObject}>Transform</Button></Col>
              </Row>
            </Col>
          </Row>
        </div>
      );
    else
      return( 
        <div>
          <Row style={{paddingTop: "10px"}}>
            <Col><p>This is an immutable object.  Versioning is not allowed.</p></Col>
          </Row>
        </div>
      );
  }

  renderVersionedObject()
  {
    var columns = 
    [
      {Header: '#', accessor: 'versionNumber', id: 'versionNumber', width: 45},
      {Header: 'Name', accessor: 'sourcePath', id: 'sourcePath' },
      {Header: 'Date', id: 'versionDate', accessor: d => {return window.formatTimestamp(d.versionDate, false)}, width: 175 }
    ]

    if ('N' === this.props.selectedObject.immutableObject)
    {    
      let acceptableTypes = {};
      acceptableTypes[this.props.selectedObject.mimeType] = ['.' + this.props.selectedObject.fileExtension];

      return( 
        <div>
          <Row style={{paddingTop: "10px"}}>
            <Col sm="3" >
              <Row style={{paddingTop: "10px"}}><Col>This is a versioned object.  To upload a new version drag-and-drop or click below.</Col></Row>
              <Row style={{paddingTop: "10px"}}>
                <Col>
                  <UploadFiles uploadNewVersion={true} objectId={this.props.selectedObject.objectId} onComplete={this.newVersionUploaded}
                    acceptableTypes={acceptableTypes} versionsMustHaveSameName={this.state.versionsHaveSameNameChecked}
                    objectName={this.props.selectedObject.objectName + '.' + this.props.selectedObject.fileExtension}
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              <Row style={{paddingTop: "10px"}}>
                <Col sm={8}>Number of versions to retain:&nbsp;
                  <FormGroup check className="form-check-inline">
                    <Label check for='unlimitedVersions'>Unlimited</Label>
                    <Input style={{ marginTop: "0.6em"}} type="checkbox" id='unlimitedVersions' onChange={this.toggleUnlimitedVersions} checked={this.state.unlimitedVersionsChecked ? "checked" : ''} />
                    &nbsp;Custom&nbsp;
                    <InputNumber min={1} max={99999} defaultValue={1} disabled={this.state.numericInputDisabled} 
                      onChange={this.versionsToRetainChanged} value={this.state.versionsToRetain} autoFocus={true} 
                      style={{maxWidth: '75px'}}/>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={8}>
                  <FormGroup check className="form-check-inline">
                    <Label check for="matchName">Name of new version must match?&nbsp;</Label>
                    <Input type="checkbox" id='matchName' onChange={this.toggleNamesMustMatch} checked={this.state.versionsHaveSameNameChecked ? "checked" : ''} />
                  </FormGroup>
                </Col> 
              </Row>
              <Row style={{paddingTop: "10px"}}>
                <Col>
                <ReactTable data={this.state.versions} showPagination={true} columns={columns} minRows={1} className="-highlight"
                  noDataText="No objects found" defaultPageSize={5} sortable={false}
                />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      );
    }
    else
      return( 
        <div>
          <Row style={{paddingTop: "10px"}}>
            <Col sm="3" >
              <Row><Col>This is an immutable object.  New versions are not allowed.</Col></Row>
            </Col>
            <Col>
              <ReactTable data={this.state.versions} showPagination={true} columns={columns} minRows={1} className="-highlight"
                noDataText="No objects found" defaultPageSize={5} sortable={false}
              />
            </Col>
          </Row>
        </div>
      );
  }

  toggleNamesMustMatch()
  {
    this.setState({versionsHaveSameNameChecked: !this.state.versionsHaveSameNameChecked}, 
      this.updateVersionSettings);
  }

  toggleUnlimitedVersions()
  {
    let numericInputDisabled = !this.state.numericInputDisabled;

    this.setState(
    {
      unlimitedVersionsChecked: !this.state.unlimitedVersionsChecked,
      versionsToRetain: this.state.unlimitedVersionsChecked ? 1 : null,
      numericInputDisabled: numericInputDisabled
    }, this.updateVersionSettings);
  }

  async transformToVersionedObject()
  {
    var bodyData = {};
    bodyData.objectId = this.props.selectedObject.objectId;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'transformToVersionedObject', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error transforming to a versioned object');    
    this.context.postNotification('info', 'Transformation complete.');
    this.props.objectTransformed();
  }

  async updateVersionSettings()
  {
    if (null === this.state.versionsToRetain && !this.state.unlimitedVersionsChecked) return;

    var bodyData = {};
    bodyData.objectId = this.props.selectedObject.objectId;
    bodyData.versionsToRetain = this.state.versionsToRetain === null ? -1 : this.state.versionsToRetain;
    bodyData.versionsHaveSameName = this.state.versionsHaveSameNameChecked ? 'Y' : 'N';

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'updateVersionSettings', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error updating version settings.');    
    this.context.postNotification('info', 'Version settings updated.');
  }

  versionsToRetainChanged(valueAsNumber, valueAsString, input)
  {
    this.setState({versionsToRetain: valueAsNumber}, this.updateVersionSettings);
  }
}

ObjectVersions.contextType = AppContext;

export default ObjectVersions